import { FC } from 'react';

import { ServiceData } from '../../../../../models/ServiceDataModel';
import { ServiceInformation } from '../OnTheWayServiceStep/ServiceInformation/ServiceInformation';
import { useStyles } from './styles';

type Props = {
  serviceData: ServiceData | undefined;
  cardTitle?: string | undefined;
};

export const InitiatedServiceStep: FC<Props> = ({ serviceData, cardTitle }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <ServiceInformation serviceData={serviceData} showStarDate cardTitle={cardTitle} />
    </div>
  );
};
